import styled from "styled-components";
import { useEffect, useState } from "react";
import { serverLine } from "../../../../controllers/network/serverLine.js";
import LoggedInBoilerplate from "../LoggedInBoilerplate.js";
import LoadingSection from "../../../helperComponents/LoadingSection.js";
import { GoLocation } from "react-icons/go";
import { PiPerson } from "react-icons/pi";
import calculateAge from "../../../../controllers/calculateAge.js";
import CustomButton from "../../../helperComponents/CustomButton.js";
import { BiPlus } from "react-icons/bi";
import getSubPath from "../../../../controllers/getSubPath.js";
import getImageURL from "../../../../controllers/getImageURL.js";
import goTo from "../../../../controllers/goTo.js";
import { RiEdit2Line } from "react-icons/ri";
import ItemPageHeader from "../../../customUiForCs/ItemPageHeader.js";
import CustomMasonry from "../../../helperComponents/CustomMasonry.js";
import EmployeeCard from "../employees/EmployeeCard.js";
import CustomLabel from "../../../customUiForCs/CustomLabel.js";
import SiteCard from "../sites/SiteCard.js";
import NomenclatureOfSite from "../nomenclature/NomenclatureOfSite.js";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 300px;
  gap: 20px;
  margin-top: 50px;
  width: 100%;
  align-items: center;
`;

const Column1 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 70vw;
`;

const Image = styled.img`
  object-fit: cover;
  width: 200px;
  border-radius: 15px;
  height: 200px;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  padding: 0 14px;
  margin-right: 10px;
`;

const Title = styled.div`
  font-size: 30px;
  font-weight: 900;
  color: var(--element);
  text-transform: capitalize;
`;

const Desc = styled.div`
  font-size: 12px;
  text-transform: capitalize;
  color: var(--elementDim);
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 10px;
`;

const TopSection = styled.div`
  background: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 15px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  gap: 15px;
`;

const PrimaryLine = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
`;

const BubbleText = styled.div`
  padding: 5px 25px;
  background-color: var(--surface);
  font-size: 14px;
  border-radius: 10px;
  color: var(--elementDim);
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
`;

const SecondaryLine = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
`;

const SecondSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const ItemsSection = styled.div`
  background: var(--surface2);
  border: 1px solid var(--border);
  border-radius: 15px;
  padding: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export default function ZonePage() {
  const [item, setItem] = useState(null);
  const [itemID, setItemID] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let newItemID = getSubPath(1);
    setItemID(newItemID);
  }, []);

  useEffect(() => {
    if (itemID) loadItemToBeEdited();
  }, [itemID]);

  let core = null;

  let titleLine1 = null;
  let titleLine2 = null;

  if (loading) {
    titleLine1 = "Page";
    titleLine2 = "De Zone";

    core = <LoadingSection />;
  } else {
    if (!item) return null;
    titleLine1 = "page de";
    titleLine2 = item.name;

    core = (
      <Container>
        <Column1>
          <ItemPageHeader
            title={item.name}
            line={[{ text: item.description }]}
            buttons={[
              {
                text: "Modifier",
                onClick: goTo(`/edit-zone/?itemID=${item._id}`),
              },
            ]}
          />

          <NomenclatureOfSite
            columns={2}
            disableZoneFilter={true}
            initialZoneID={itemID}
          />
        </Column1>
      </Container>
    );
  }

  return (
    <LoggedInBoilerplate
      showBackButton={true}
      titleLine1={titleLine1}
      titleLine2={titleLine2}
    >
      {core}
    </LoggedInBoilerplate>
  );

  async function loadItemToBeEdited() {
    setLoading(true);
    let data = await serverLine.get(`/zone/?itemID=${itemID}`);
    setItem(data);
    setLoading(false);
  }
}
